// creating epicor jobs type

export const CREATE_EPICOR_JOBS_REQUEST = 'CREATE_EPICOR_JOBS_REQUEST';
export const CREATE_EPICOR_JOBS_SUCCESS = 'CREATE_EPICOR_JOBS_SUCCESS';
export const CREATE_EPICOR_JOBS_FAIL = 'CREATE_EPICOR_JOBS_FAIL';

// creating estimator epicor jobs type

export const CREATE_ESTMATOR_EPICOR_JOBS_REQUEST =
  'CREATE_ESTMATOR_EPICOR_JOBS_REQUEST';
export const CREATE_ESTMATOR_EPICOR_JOBS_SUCCESS =
  'CREATE_ESTMATOR_EPICOR_JOBS_SUCCESS';
export const CREATE_ESTMATOR_EPICOR_JOBS_FAIL =
  'CREATE_ESTMATOR_EPICOR_JOBS_FAIL';

export const CLEAR_ESTIMATOR_EPI_JOBS_STATE = 'CLEAR_ESTIMATOR_EPI_JOBS_STATE';
